import { ErrorOutline, InfoOutlined } from '@mui/icons-material';
import CheckIcon from '@mui/icons-material/Check';
import { warnOrange } from 'common/styles/colors';
import { ToastContent, toast } from 'react-toastify';

const toastCloseDelay = 5000;

export const showSuccessMessage = (message: string): void => {
  toast.success(message, {
    autoClose: toastCloseDelay,
    icon: <CheckIcon />,
  });
};

export const showWarningMessage = (message: string): void => {
  toast.warning(message, {
    autoClose: toastCloseDelay,
    icon: <InfoOutlined />,
    style: {
      backgroundColor: warnOrange,
    },
  });
};

export const showErrorMessage = (message: string | ToastContent): void => {
  toast.error(message, {
    autoClose: toastCloseDelay,
    icon: <ErrorOutline />,
  });
};
